export function formatWatermarkText({
  activityType,
  lat,
  lng,
  accuracy,
  cases,
  sacks,
  extraLine,
}) {
  const ts = new Date();
  const dt = ts.toLocaleString();
  const lines = [
    `POD • ${activityType.toUpperCase()} • ${dt}`,
    `Lat ${lat.toFixed(6)}  Lng ${lng.toFixed(6)}  ±${Math.round(accuracy)}m`,
    `Cases: ${cases}  Sacks: ${sacks}`,
  ];
  if (extraLine) lines.push(extraLine);
  return lines;
}

export function drawWatermark(ctx, lines, width, height) {
  const pad = Math.max(8, Math.round(width * 0.012));
  const boxH = Math.round(Math.min(70, height * 0.10));

  ctx.save();
  
  // Very subtle transparent background at TOP (10% opacity)
  ctx.globalAlpha = 0.10;
  ctx.fillStyle = "#0B1220";
  ctx.fillRect(pad, pad, width - pad * 2, boxH);

  // Subtle border
  ctx.globalAlpha = 0.3;
  ctx.strokeStyle = "rgba(56,189,248,0.3)";
  ctx.lineWidth = 1;
  ctx.strokeRect(pad, pad, width - pad * 2, boxH);

  // Text - smaller font (about 10% of box height)
  ctx.globalAlpha = 1;
  ctx.fillStyle = "#FFFFFF";
  ctx.font = `600 ${Math.max(9, Math.round(width * 0.018))}px ui-sans-serif, system-ui`;
  
  // Strong text shadow for readability on transparent bg
  ctx.shadowColor = "rgba(0, 0, 0, 0.95)";
  ctx.shadowBlur = 2;
  ctx.shadowOffsetX = 1;
  ctx.shadowOffsetY = 1;

  const lineGap = Math.max(12, Math.round(width * 0.028));
  let y = pad + Math.max(16, Math.round(width * 0.035));
  for (let i = 0; i < lines.length; i += 1) {
    const line = lines[i];
    ctx.fillText(line, pad + Math.max(8, Math.round(width * 0.015)), y);
    y += lineGap;
  }

  ctx.restore();
}
